module.exports = __webpack_public_path__ + "static/media/card-testimonial3-square.18d463e7.png";